export default "__VITE_ASSET__cyWKUQxJ__"